import { render, staticRenderFns } from "./TractFiles.vue?vue&type=template&id=229872fd&"
import script from "./TractFiles.vue?vue&type=script&lang=js&"
export * from "./TractFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports